<template>
	<section id="nosotros" class="white">
		<v-container id="container" class="py-15">
			<v-row align="center" class="py-15">
				<v-col cols="12">
					<v-row justify="center">
						<v-col cols="10" md="5">
							<v-row>
								<v-col v-for="(foto, i) in recuadro" :key="i" class="d-flex child-flex pa-0" cols="4">
									<v-img
										:src="foto.img"
										:lazy-src="`https://picsum.photos/10/6?image=${i++ + 10}`"
										aspect-ratio="1"
										class="rounded-lg grey lighten-2"
									>
										<template v-slot:placeholder>
											<v-row class="fill-height ma-0" align="center" justify="center">
												<v-progress-circular
													indeterminate
													color="grey lighten-5"
												></v-progress-circular>
											</v-row>
										</template>
									</v-img>
								</v-col>
							</v-row>
							<!-- <v-img
                class="my-10"
                max-width="500"
                src="@/assets/img/intro.png"
                contain
              /> -->
						</v-col>
						<v-col
							cols="12"
							md="5"
							align-self="center"
							justify="center"
							class="py-10 pa-5 px-md-15 anim"
							v-scrollanimation
						>
							<!-- <v-img class="mt-md-15" height="256" src="@/assets/img/intro2.png" contain /> -->
							<p v-scrollanimation class="grisClaro--text">
								<b>{{ $t('intro.sola') }}</b> {{ $t('intro.1') }}
							</p>
							<br />
							<span v-scrollanimation class="grisClaro--text">
								<p>
									{{ $t('intro.2A') }} <b>{{ $t('intro.2B') }}</b>{{ $t('intro.2C') }}
                  <b>{{ $t('intro.2D') }}</b>{{ $t('intro.2E') }}
								</p>
							</span>
							<br />
							<p v-scrollanimation class="grisClaro--text">
								{{ $t('intro.3') }}
							</p>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>
		<!-- <v-parallax
      class="px-0 mx-0"
      height="500"
      dark
      src="@/assets/img/parallax/parallax.jpg"
    > -->
		<v-container fluid class="azulMuyClaro py-15 px-0 mx-0">
			<v-row align="center" justify="center">
				<v-col>
					<p id="titulo" v-scrollanimation class="neftysBlue--text text-center text-h4 text-md-h3 mb-4">
						{{ $t('intro.titulo') }}
					</p>
				</v-col>
			</v-row>
			<v-row align="center" justify="center" class="my-15">
				<v-col cols="11">
					<v-row align="start" justify="center" class="my-md-10">
						<v-col v-scrollanimation cols="12" md="4" class="d-flex">
							<v-img max-width="64">
								<svg
									width="64px"
									height="64px"
									viewBox="-296.96 -296.96 1617.92 1617.92"
									class="icon"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									fill="#099247"
									stroke="#099247"
									stroke-width="20.48"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0">
										<path
											transform="translate(-296.96, -296.96), scale(101.12)"
											fill="#099247"
											d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
											strokewidth="0"
										></path>
									</g>
									<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
									<g id="SVGRepo_iconCarrier">
										<path
											d="M731.25 547.39v72.93H475.06v54.59c0 19.89 4.93 38.51 13.04 55.34h-38.49l-194.73-128c-28.84-18.98-65.64-20.57-96.07-4.18a93.73 93.73 0 0 0-49.29 82.57c0 32.05 16.09 61.54 43.04 78.88l238.79 153.77h339.9v36.57H914.1V547.39H731.25z m-318.4 292.75l-220.7-142.12a20.6 20.6 0 0 1-9.48-17.38c0-11.12 7.59-16.43 10.86-18.2 3.29-1.73 11.88-5.18 21.18 0.91l213.02 140.04h230.7v-73.14h-0.71v-0.04h-54.2c-23.98 0-44.46-15.36-52.11-36.75h179.85v146.68H412.85z m428.11 36.57h-36.57V620.53h36.57v256.18zM232.17 501.66c-20.46-35.7-31.27-76.48-31.27-117.95C200.9 252.64 307.51 146 438.54 146 569.6 146 676.2 252.64 676.2 383.71c0 41.43-10.8 82.21-31.25 117.91l63.46 36.36c26.79-46.77 40.93-100.11 40.93-154.27 0-171.41-139.43-310.86-310.8-310.86S127.76 212.3 127.76 383.71c0 54.2 14.16 107.55 40.95 154.3l63.46-36.35z"
											fill="#fff"
										></path>
										<path
											d="M336.22 350.91l-48.78 54.48 136.73 122.47 170.36-195.97-55.22-48-121.64 139.97z"
											fill="#fff"
										></path>
									</g>
								</svg>
							</v-img>
							<h3 v-scrollanimation class="neftysBlue--text ml-5">
								{{ $t('intro.text1') }}
							</h3>
						</v-col>

						<v-col v-scrollanimation cols="12" md="4" class="d-flex">
							<v-img max-width="64">
								<svg
									width="64px"
									height="64px"
									viewBox="-307.2 -307.2 1638.40 1638.40"
									class="icon"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									fill="#099247"
									stroke="#099247"
									stroke-width="20.48"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0">
										<path
											transform="translate(-307.2, -307.2), scale(102.4)"
											fill="#099247"
											d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
											strokewidth="0"
										></path>
									</g>
									<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
									<g id="SVGRepo_iconCarrier">
										<path
											d="M859.4 365.7c-8.9 0-17.5 1.3-25.7 3.7-32-148.2-164.1-259.7-321.7-259.7S222.2 221.2 190.3 369.4c-8.2-2.4-16.8-3.7-25.7-3.7-50.4 0-91.4 41-91.4 91.4v109.7c0 50.4 41 91.4 91.4 91.4s91.4-41 91.4-91.4V438.8c0-141.2 114.8-256 256-256s256 114.8 256 256v109.7c0 92.1-48.9 175.4-127.1 221-16.6-23.1-43.7-38.1-74.2-38.1H457c-50.4 0-91.4 41-91.4 91.4 0 50.4 41 91.4 91.4 91.4h109.7c42.9 0 79-29.8 88.8-69.7 81.6-39.6 141.8-109.7 169.2-193.1 10.7 4.4 22.4 6.8 34.7 6.8 50.4 0 91.4-41 91.4-91.4V457.1c0.1-50.4-41-91.4-91.4-91.4zM182.9 566.9c0 10.1-8.2 18.3-18.3 18.3s-18.3-8.2-18.3-18.3V457.1c0-10.1 8.2-18.3 18.3-18.3s18.3 8.2 18.3 18.3v109.8z m383.8 274.3H457c-10.1 0-18.3-8.2-18.3-18.3 0-10.1 8.2-18.3 18.3-18.3h109.7c10.1 0 18.3 8.2 18.3 18.3 0 10.1-8.2 18.3-18.3 18.3z m311-274.3c0 10.1-8.2 18.3-18.3 18.3s-18.3-8.2-18.3-18.3V457.2c0-10.1 8.2-18.3 18.3-18.3s18.3 8.2 18.3 18.3v109.7z"
											fill="#fff"
										></path>
										<path
											d="M512 658.3c80.7 0 146.3-65.6 146.3-146.3h-73.1c0 40.3-32.8 73.1-73.1 73.1S439 552.3 439 512h-73.1c-0.2 80.7 65.4 146.3 146.1 146.3z"
											fill="#fff"
										></path>
									</g>
								</svg>
							</v-img>
							<h3 v-scrollanimation class="d-flex neftysBlue--text ml-5 text-left">
								{{ $t('intro.text2') }}
							</h3>
						</v-col>
					</v-row>
					<v-row align="start" justify="center" class="my-md-10">
						<v-col v-scrollanimation cols="12" md="4" class="d-flex">
							<v-img max-width="64">
								<svg
									width="64px"
									height="64px"
									viewBox="-307.2 -307.2 1638.40 1638.40"
									class="icon"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									fill="#099247"
									stroke="#099247"
									stroke-width="20.48"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0">
										<path
											transform="translate(-307.2, -307.2), scale(102.4)"
											fill="#099247"
											d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
											strokewidth="0"
										></path>
									</g>
									<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
									<g id="SVGRepo_iconCarrier">
										<path
											d="M895.3 278.8L529.6 77.7c-11-6.1-24.3-6-35.2 0l-154.5 85c-13.4-9.4-29.7-15-47.3-15-45.4 0-82.3 36.9-82.3 82.3s36.9 82.3 82.3 82.3 82.3-36.9 82.3-82.3c0-1 0-2-0.1-3L512 151.4l329.1 181v359L512 872.6l-329.1-181V445.9l292.6 92.9v82.4c-27.1 13.5-45.7 41.4-45.7 73.7 0 45.4 36.9 82.3 82.3 82.3s82.3-36.9 82.3-82.3c0-32.2-18.6-60.2-45.7-73.7v-87.7l81.7-45.4c13.2 8.9 29 14.2 46.1 14.2 45.4 0 82.3-36.9 82.3-82.3s-36.9-82.3-82.3-82.3-82.3 36.9-82.3 82.3c0 1.5 0 3 0.1 4.5L508 472.4 157.4 361c-11.1-3.5-23.2-1.6-32.7 5.3-9.4 6.9-15 17.9-15 29.5v317.3c0 13.3 7.3 25.6 18.9 32l365.7 201.1c5.5 3 11.6 4.5 17.6 4.5s12.1-1.5 17.6-4.5l365.7-201.1c11.7-6.4 18.9-18.7 18.9-32V310.9c0.2-13.4-7.1-25.7-18.8-32.1z m-602.7-21.4c-15.1 0-27.4-12.3-27.4-27.4s12.3-27.4 27.4-27.4S320 214.9 320 230s-12.3 27.4-27.4 27.4z m383.8 135.2c15.1 0 27.4 12.3 27.4 27.4s-12.3 27.4-27.4 27.4S649 435.1 649 420s12.3-27.4 27.4-27.4zM512 722.3c-15.1 0-27.4-12.3-27.4-27.4s12.3-27.4 27.4-27.4 27.4 12.3 27.4 27.4-12.3 27.4-27.4 27.4z"
											fill="#fff"
										></path>
									</g>
								</svg>
							</v-img>
							<h3 v-scrollanimation class="neftysBlue--text ml-5">
								{{ $t('intro.text3') }}
							</h3>
						</v-col>

						<v-col v-scrollanimation cols="12" md="4" class="d-flex">
							<v-img max-width="64">
								<svg
									width="64px"
									height="64px"
									viewBox="-307.2 -307.2 1638.40 1638.40"
									class="icon"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									fill="#099247"
									stroke="#099247"
									stroke-width="20.48"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0">
										<path
											transform="translate(-307.2, -307.2), scale(102.4)"
											fill="#099247"
											d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
											strokewidth="0"
										></path>
									</g>
									<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
									<g id="SVGRepo_iconCarrier">
										<path d="M793.87 486.14l-99-99V256h-73.15v161.43l120.43 120.43z" fill="#fff"></path>
										<path
											d="M950.87 109.71H365.72V256h-139.7l-39.48 197.41L73.15 529v275.57h114.31c16.24 63.09 73.51 109.71 141.68 109.71 68.16 0 125.44-46.62 141.68-109.71h118.93c16.24 63.09 73.51 109.71 141.68 109.71 68.16 0 125.44-46.62 141.68-109.71h77.76V109.71zM329.14 841.14c-40.33 0-73.14-32.81-73.14-73.14s32.81-73.14 73.14-73.14 73.14 32.81 73.14 73.14-32.81 73.14-73.14 73.14z m402.29 0c-40.33 0-73.14-32.81-73.14-73.14s32.81-73.14 73.14-73.14 73.14 32.81 73.14 73.14-32.81 73.14-73.14 73.14z m146.29-109.71h-4.62c-16.24-63.09-73.51-109.71-141.68-109.71-68.16 0-125.44 46.62-141.68 109.71H470.82c-16.24-63.09-73.51-109.71-141.68-109.71-68.16 0-125.44 46.62-141.68 109.71h-41.17V568.14l106.04-70.7 33.66-168.3h79.73v219.43h73.14V182.86h438.86v548.57z"
											fill="#fff"
										></path>
									</g>
								</svg>
							</v-img>
							<h3 v-scrollanimation class="neftysBlue--text ml-5">
								{{ $t('intro.text4') }}
							</h3>
						</v-col>
					</v-row>
					<v-row align="start" justify="center" class="my-md-10">
						<v-col v-scrollanimation cols="12" md="4" class="d-flex">
							<v-img max-width="64">
								<svg
									width="64px"
									height="64px"
									viewBox="-307.2 -307.2 1638.40 1638.40"
									class="icon"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									fill="#099247"
									stroke="#099247"
									stroke-width="20.48"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0">
										<path
											transform="translate(-307.2, -307.2), scale(102.4)"
											fill="#099247"
											d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
											strokewidth="0"
										></path>
									</g>
									<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
									<g id="SVGRepo_iconCarrier">
										<path
											d="M749.7 548.7l-164.6 91.4V823l164.6 91.4L914.3 823V640.1l-164.6-91.4zM841.1 780l-91.4 50.8-91.4-50.8v-96.8l91.4-50.8 91.4 50.8V780z"
											fill="#fff"
										></path>
										<path
											d="M713.600831 737.455926a36.6 36.6 0 1 0 72.255718-11.719698 36.6 36.6 0 1 0-72.255718 11.719698Z"
											fill="#fff"
										></path>
										<path
											d="M688.7 479.8c-12.7-6.2-25.7-11.8-38.9-16.6 49.8-40.3 81.6-101.8 81.6-170.6 0-121-98.4-219.4-219.4-219.4s-219.4 98.4-219.4 219.4c0 68.9 31.9 130.5 81.7 170.7-154.2 56.4-264.6 204.5-264.6 378h73.1c0-181.5 147.7-329.1 329.1-329.1 50.7 0 99.3 11.2 144.5 33.3l32.3-65.7zM512 146.3c80.7 0 146.3 65.6 146.3 146.3S592.7 438.9 512 438.9s-146.3-65.6-146.3-146.3S431.4 146.3 512 146.3z"
											fill="#fff"
										></path>
									</g>
								</svg>
							</v-img>
							<h3 v-scrollanimation class="neftysBlue--text ml-5">
								{{ $t('intro.text5') }}
							</h3>
						</v-col>

						<v-col v-scrollanimation cols="12" md="4" class="d-flex">
							<v-img max-width="64">
								<svg
									width="64px"
									height="64px"
									viewBox="-307.2 -307.2 1638.40 1638.40"
									class="icon"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									fill="#099247"
									stroke="#099247"
									stroke-width="20.48"
								>
									<g id="SVGRepo_bgCarrier" stroke-width="0">
										<path
											transform="translate(-307.2, -307.2), scale(102.4)"
											fill="#099247"
											d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
											strokewidth="0"
										></path>
									</g>
									<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
									<g id="SVGRepo_iconCarrier">
										<path
											d="M512 365.7c60.6 0 109.7-49.1 109.7-109.7S572.6 146.3 512 146.3 402.3 195.4 402.3 256 451.4 365.7 512 365.7z m0-146.3c20.2 0 36.6 16.4 36.6 36.6s-16.4 36.6-36.6 36.6-36.6-16.4-36.6-36.6 16.4-36.6 36.6-36.6zM417.4 398.5L384.8 333c-98 48.7-158.9 146.9-158.9 256.3H299c0.1-81.5 45.4-154.6 118.4-190.8zM378.9 755.5l-45.8 57.1c50.5 40.5 114 62.8 178.8 62.8s128.3-22.3 178.8-62.8l-45.8-57.1c-76 61.1-189.8 61.1-266 0zM724.9 589.3H798c0-109.4-60.9-207.6-158.9-256.3l-32.5 65.5c73 36.2 118.3 109.3 118.3 190.8zM219.4 621.7c-60.6 0-109.7 49.1-109.7 109.7s49.1 109.7 109.7 109.7S329.1 792 329.1 731.4 280 621.7 219.4 621.7z m0 146.3c-20.2 0-36.6-16.4-36.6-36.6 0-20.2 16.4-36.6 36.6-36.6 20.2 0 36.6 16.4 36.6 36.6 0 20.2-16.4 36.6-36.6 36.6zM804.6 621.7c-60.6 0-109.7 49.1-109.7 109.7S744 841.1 804.6 841.1 914.3 792 914.3 731.4s-49.1-109.7-109.7-109.7z m0 146.3c-20.2 0-36.6-16.4-36.6-36.6 0-20.2 16.4-36.6 36.6-36.6s36.6 16.4 36.6 36.6c-0.1 20.2-16.5 36.6-36.6 36.6z"
											fill="#fff"
										></path>
									</g>
								</svg>
							</v-img>
							<h3 v-scrollanimation class="neftysBlue--text ml-5">
								{{ $t('intro.text6') }}
							</h3>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>
		<!-- </v-parallax> -->
	</section>
</template>

<script>
export default {
	name: 'Intro',
	data() {
		return {
			recuadro: [
        {
          img: require('@/assets/img/neftys/we/6.jpg'),
        },
        {
          img: require('@/assets/img/neftys/we/2.jpg'),
        },
        {
          img: require('@/assets/img/neftys/we/9.jpg'),
        },
        {
          img: require('@/assets/img/neftys/we/7.jpg'),
        },
        {
          img: require('@/assets/img/neftys/we/5.jpg'),
        },
        {
          img: require('@/assets/img/neftys/we/8.jpg'),
        },
        {
          img: require('@/assets/img/neftys/we/4.jpg'),
        },
				{
					img: require('@/assets/img/neftys/we/1.jpg'),
				},
				{
					img: require('@/assets/img/neftys/we/3.jpg'),
				}
			],
		};
	},
};
</script>

<style scoped>
section {
	min-height: 60vh;
}
</style>
